import React from 'react';
import useTranslation from '../../hooks/useTranslation';

/**
 * Map status chip, top-left: "N karren rijden nu".
 * Purely presentational; N derived from the karren array TrackerView polls.
 */
function StatusChip({ karren = [] }) {
    const { t } = useTranslation();
    const count = karren.filter(k => k.available).length;

    const label = count === 1
        ? t('tracker.statusChip.one', '1 kar rijdt nu')
        : t('tracker.statusChip.many', '{count} karren rijden nu').replace('{count}', String(count));

    return (
        <div className="tracker-status-chip" role="status">
            <span className={`tracker-status-dot ${count > 0 ? 'on' : 'off'}`} />
            {label}
        </div>
    );
}

export default StatusChip;
